import { render } from "./OverlayAuthWindow.vue?vue&type=template&id=2f35a62a&scoped=true"
import script from "./OverlayAuthWindow.vue?vue&type=script&lang=js"
export * from "./OverlayAuthWindow.vue?vue&type=script&lang=js"

import "./overlayAuthWindow.css?vue&type=style&index=0&id=2f35a62a&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f35a62a"]])

export default __exports__